import { render, staticRenderFns } from "./CreateVoice.vue?vue&type=template&id=96f79dfe&scoped=true"
import script from "./CreateVoice.vue?vue&type=script&lang=js"
export * from "./CreateVoice.vue?vue&type=script&lang=js"
import style0 from "./CreateVoice.vue?vue&type=style&index=0&id=96f79dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f79dfe",
  null
  
)

export default component.exports